import { useGlobalQuery } from '@/state/query-client/hooks';
import { graphqlClient } from '@/lib/graphql-client';
import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

export interface LookupItem {
  ItemId: string;
  Title: string;
}

const buildGetServiceDeskDepartmentsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Departments: getDepartments(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      items {
        ItemId
        Title
      }
    }
  }
`;

export const useServiceDeskDepartments = () =>
  useGlobalQuery({
    queryKey: ['hr-service-desk-departments'],
    queryFn: async () => {
      const result = await graphqlClient.query<{ Departments: { items: LookupItem[] } }>({
        query: buildGetServiceDeskDepartmentsQuery({}, 1, 200),
      });
      // The whole list is one page, so it is sorted here by `Title`, like the legacy
      // `{ Title: 1 }` sort (DepartmentService.cs:229).
      return [...result.Departments.items].sort((a, b) => a.Title.localeCompare(b.Title));
    },
    staleTime: 10 * 60 * 1000,
  });
